import { brands } from 'noddi-types';
import { useCurrentBrand } from '../stores/BrandStore/brandStore';

export const useIsNoddiBrand = () => {
  const { currentBrand } = useCurrentBrand();
  return currentBrand === brands.noddi;
};
